module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_21_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/modelace-postavy-liposukce_21_before.jpg
// module id = 1108
// module chunks = 0